import React from 'react';
import { HowItWorksConnections } from '../components/HowItWorksConnections';
import { LivesInSlack } from '../components/LivesInSlack';
import { ComputerUse } from '../components/ComputerUse';
import { ProofPointsGrid } from '../components/ProofPointsGrid';
import { CapabilityGrid } from '../components/CapabilityGrid';
import { NarrativeSection } from '../components/NarrativeSection';
import { ToolComparison } from '../components/ToolComparison';
import { WallOfLove } from '../components/WallOfLove';
import { GettingStartedSteps } from '../components/GettingStartedSteps';
import { PricingSection } from '../components/PricingSection';
import { ClosingCTA } from '../components/ClosingCTA';
import { AudienceSwitch } from '../components/AudienceSwitch';
import { NovaSection } from '../components/nova/NovaSection';
import { SlackIntegrationGraphCardMorph } from '../components/SlackIntegrationGraphCardMorph';
// New Giga home screen. The hero is the "Ask Giga anything, get it done."
// chat-box composer (HowItWorksConnections in hero mode), presented as a
// proper website hero. The Slack "@mention Giga" experience remains its own
// "Works where you work" section further down the page.
// The "AI Co-Pilot for Teams" homepage still lives at /future.
export function Home() {
  return <>
      <HowItWorksConnections mode="hero" data-id="element-4610" />
      {/* <NovaSection /> Hidden per user request */}
      {/* "Works where you work" → "Works right in your chats" now uses the
                      refined card-morph transition (typed "@Giga …" prompt that resolves
                      into the chat panel) that we proved out on /chat-transition. */}
      <SlackIntegrationGraphCardMorph data-id="element-4611" />
      {/* "How it works" / Plug-and-play moved above the Giga for You / Team
                              audience switch per the intended narrative flow. */}
      <GettingStartedSteps data-id="element-4612" />
      <AudienceSwitch data-id="element-4613" />
      {/* <LivesInSlack /> Hidden from home for now — kept for reuse on another page later */}
      {/* "Built to do the work…" capability grid (four items) leads, then the
                          "Giga brings its own computer" proof beat — which stays ahead of the
                          reviews (WallOfLove) below. */}
      <CapabilityGrid data-id="element-4614" />
      <ProofPointsGrid data-id="element-4615" />
      <NarrativeSection data-id="element-4616" />
      <ToolComparison data-id="element-4617" />
      <WallOfLove data-id="element-4618" />
      {/* <PricingSection /> Hidden from home for now — still a waitlist. Kept
                          for reuse; bring back when pricing goes live. */}
      <ClosingCTA data-id="element-4619" />
    </>;
}